import React from "react";

type TopBarProps = {
  title: string;
  subtitle: string;
};

const wrapperStyle: React.CSSProperties = {
  width: "100%",
  background: "var(--surface)",
  borderRadius: "32px",
  padding: "28px 30px",
  boxShadow: "0 18px 50px rgba(20, 20, 20, 0.06)",
  border: "1px solid var(--line)",
  marginBottom: "24px",
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) auto",
  gap: "20px",
  alignItems: "center",
};

const textWrapStyle: React.CSSProperties = {
  minWidth: "0",
};

const titleStyle: React.CSSProperties = {
  margin: "0 0 10px 0",
  fontSize: "38px",
  lineHeight: 1.05,
  fontWeight: 800,
  letterSpacing: "-0.04em",
  color: "var(--text)",
  fontFamily: "Montserrat",
  textTransform: "uppercase",
};

const subtitleStyle: React.CSSProperties = {
  margin: 0,
  maxWidth: "720px",
  fontSize: "15px",
  lineHeight: 1.7,
  color: "var(--text-muted)",
};

const rightWrapStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
  justifyContent: "flex-end",
};

const statusCardStyle: React.CSSProperties = {
  minWidth: "190px",
  padding: "16px 18px",
  borderRadius: "22px",
  background: "var(--surface-2)",
  border: "1px solid var(--line)",
};

const statusLabelStyle: React.CSSProperties = {
  margin: "0 0 6px 0",
  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: "var(--text-dim)",
};

const statusValueStyle: React.CSSProperties = {
  margin: 0,
  fontSize: "16px",
  fontWeight: 800,
  color: "var(--text)",
};

const buttonStyle: React.CSSProperties = {
  height: "50px",
  border: "none",
  borderRadius: "999px",
  padding: "0 22px",
  background: "var(--accent)",
  color: "var(--on-accent)",
  fontSize: "14px",
  fontWeight: 800,
  cursor: "pointer",
  transition: "0.2s ease",
  boxShadow: "var(--glow)",
};

const TopBar: React.FC<TopBarProps> = ({ title, subtitle }) => {
  const handleLogout = () => {
    localStorage.removeItem("auth");
    window.location.reload();
  };

  return (
    <div style={wrapperStyle}>
      <div style={textWrapStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
          <img src="/images/batya-logo.png" alt="БАТЯ ЗНАЕТ" style={{ height: "40px", display: "block" }} />
          <span style={{ fontFamily: "Montserrat", fontSize: "11px", fontWeight: 800, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--text-dim)" }}>Admin</span>
        </div>

        <h2 style={titleStyle}>{title}</h2>
        <p style={subtitleStyle}>{subtitle}</p>
      </div>

      <div style={rightWrapStyle}>
        <div style={statusCardStyle}>
          <p style={statusLabelStyle}>Статус системы</p>
          <p style={statusValueStyle}>Онлайн</p>
        </div>

        <button
          style={buttonStyle}
          onClick={handleLogout}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "var(--accent-hover)";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "var(--accent)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          Выйти
        </button>
      </div>
    </div>
  );
};

export default TopBar;
